import { RoomType } from '@lib/api';

export const residentialRoomTypes = [
  'Bedroom',
  'Kitchen',
  'LivingRoom',
  'DiningRoom',
  'KidsRoom',
  'Corridor',
  'Bathroom',
  'Toilet',
  'WorkRoom',
  'Other',
] as RoomType[];
export const commercialRoomTypes = [
  'MeetingRoom',
  'Office',
  'QuietRoom',
  'CallRoom',
  'BreakRoom',
  'PresentationRoom',
  'OpenOffice',
  'Other',
] as RoomType[];
export const publicRoomTypes = [
  'Parking',
  'Entrance',
  'Lobby',
  'Reception',
  'UtilityRoom',
  'ServerRoom',
  'TechRoom',
  'Staircase',
  'StorageRoom',
  'Warehouse',
  'Other',
] as RoomType[];

const combinedTypes = [...residentialRoomTypes, ...commercialRoomTypes, ...publicRoomTypes];
export const combinedRoomTypes = combinedTypes.filter((item, index) => combinedTypes.indexOf(item) === index).sort();
